import { OperPostActions } from '..'
import { HttpServiceResponse } from '../../shared'
import { ApplicationOperPostParams } from '../models/oper/oper_post-params.model'
import AbstractApplicationProvider from './application-abstract.provider'

export class OperPostProvider extends AbstractApplicationProvider {
  urlPath = 'application_oper_post_api'

  public oper_post<T = any>(
    action: OperPostActions,
    { AppID, HashSum_AppID_, Comment }: ApplicationOperPostParams,
  ): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
      AppID,
      HashSum_AppID_,
    })

    return this.http.post(`${this.url}?${query}`, {
      Comment,
    })
  }
}
